import api from "services/api";
import type {
  DashboardFinanceiroApiResponse,
  DashboardFinanceiroParams,
} from "../types/financeiro-dashboard.types";
import { granularidadeParaApi } from "../helpers/granularidade-api";

export async function obterDashboardFinanceiro(
  params?: DashboardFinanceiroParams
): Promise<{ data: DashboardFinanceiroApiResponse | null; status: number }> {
  const search = new URLSearchParams();
  if (params?.dataInicio) search.set("dataInicio", params.dataInicio);
  if (params?.dataFim) search.set("dataFim", params.dataFim);
  if (params?.granularidade) {
    search.set("granularidade", granularidadeParaApi[params.granularidade]);
  }
  if (params?.tipoDataInscricoes) {
    search.set("tipoDataInscricoes", params.tipoDataInscricoes);
  }
  const qs = search.toString();
  const url = `/loja/financeiro/dashboard${qs ? `?${qs}` : ""}`;
  const res = await api.get<DashboardFinanceiroApiResponse>(url);
  const status = res.status;
  if (status !== 200) {
    return { data: null, status };
  }
  return { data: res.data ?? null, status };
}
